import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-0 pb-16 overflow-hidden" data-id="element-147">
      {/* Alert Bar */}
      <div className="w-full bg-brand-red text-white text-center py-3 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-148">
        🔥 OFERTA RELAMPAGO: SOLO POR HOY +3 BONOS GRATIS
      </div>

      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-red/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-149" />

      <div className="max-w-4xl mx-auto text-center z-10 relative pt-10 px-4" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-151">
          <div className="inline-block bg-brand-red/10 border border-brand-red/20 text-brand-red font-semibold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-152">
            ⭐️ +10,000 lectores transformados
          </div>

          <h1 className="md:text-6xl lg:text-7xl mb-6 text-[32px] font-[700]" data-id="element-153">
            Dura{' '}
            <span className="underline decoration-brand-red/50 underline-offset-4" data-id="element-154">
              exactamente lo que quieras
            </span>{' '}
            en la cama, desde los primeros{' '}
            <span className="bg-brand-gold/10 px-1 rounded text-brand-gold" data-id="element-155">
              7 días
            </span>
            ,{' '}
            <span className="text-brand-red font-bold" data-id="element-156">
              sin usar retardantes
            </span>
            , sin pastillas ni apps de ejercicios eternos
          </h1>

          <p className="md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto font-[400] text-[20px]" data-id="element-157">
            Con el Método Taoísta de Control Corporal Total vas a aprender a{' '}
            <strong className="text-white" data-id="element-158">decidir conscientemente</strong>{' '}
            cuándo terminar y convertirte en el{' '}
            <strong className="text-brand-gold" data-id="element-159">
              HOMBRE que la vuelve loca
            </strong>{' '}
            🌊
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative w-full max-w-md mx-auto mb-8" data-id="element-160">
          <img src="https://cdn.magicpatterns.com/uploads/a6SZ8MyHMpZnkfyYdRv5Uj/c0c72188-644d-4693-9874-6a2ee1b6412f.jpg" alt="Precoz Nunca Más - Control Total" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-161" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-162">
          <Button data-id="element-163">QUIERO EL MÉTODO</Button>
          <p className="text-sm text-gray-500 mt-4 flex items-center justify-center gap-2" data-id="element-164">
            ⚡️ DESCARGA INMEDIATA ✅ PAGO ÚNICO
          </p>
        </motion.div>
      </div>
    </section>;
}